<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-shopping" icon-small :title="title" color="accent" class="px-5">
			<v-row>
				<v-col cols="12" md="3">
				</v-col>
				<v-col cols="12" md="6">
					<date-navigator v-model="dateRange" :options="{ rangeMode: true, defaultEmpty: hasCustomer }">
						<div class="text-center">
							<v-btn color="primary" small dark class="mx-1" @click="loadData">
								دریافت اطلاعات
							</v-btn>
						</div>
					</date-navigator>
				</v-col>
				<v-col cols="12" md="3" class="d-flex align-center justify-end">
					<export-excel :items="items" :headers="headers" :fileName="excelFileName">
					</export-excel>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12" v-if="filters.length">
					<span class="ml-2">فیلتر:</span>
					<v-btn-toggle v-model="filter" dense tile outlined color="purple" class="mr-2 flex-wrap">
						<v-btn v-for="status in filters" :key="status" :value="status" small>
							{{ translate(status) }}
							<v-badge color="blue" :content="status === 'همه' ? items.length : items.filter(x => x.productType == status).length || '0'" inline>
							</v-badge>
						</v-btn>
					</v-btn-toggle>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12">
					<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو را وارد کنید" single-line hide-details class="mb-5" />
				</v-col>
				<v-col cols="12">
					<v-data-table :headers="headers" :loading="loading" :items="filterItems" :footer-props="{ 'items-per-page-options': [5, 15, 50, 100] }" :items-per-page="50" :search="search" class="elevation-1 mb-10">
						<template v-slot:item.customer.name="{ item }">
							<div class="text-right info--text" style="cursor:pointer" @click="showManageCustomer(item.customer)">
								<small>{{ item.customer.name }}</small>
							</div>
						</template>
						<template v-slot:item.description="{ item }">
							<small>{{ item.description }}</small>
						</template>
						<template v-slot:item.startDate_Persian="{ item }">
							<div><small>{{ item.startDate_Persian.date }}</small></div>
							<div><small>{{ item.startDate_Persian.time }}</small></div>
						</template>
						<template v-slot:item.onlinePaymentGatewayText="{ item }">
							<small>{{ item.onlinePaymentGatewayText }}</small>
						</template>
						<template v-slot:item.amount="{ item }">
							{{ item.amount.toString().toPriceFormat() }}
						</template>
						<template v-slot:item.zarinPalPurchase="{ item }">
							<gateway-details :data="item" />
						</template>
						<template v-slot:item.isPaymentSuccess="{ item }">
							<div class="d-flex justify-center" :class="[paymentSuccessColor(item.isPaymentSuccess) + '--text']">
								<v-icon :color="paymentSuccessColor(item.isPaymentSuccess)" small inline class="ml-1">
									{{ paymentSuccessIcon(item.isPaymentSuccess) }}
								</v-icon>
								{{ item.isPaymentSuccess ? 'موفق' : 'ناموفق' }}
							</div>
						</template>
					</v-data-table>
				</v-col>
			</v-row>

			<v-dialog v-model="dialogCustomerManager" scrollable max-width="1200px">
				<v-card>
					<v-card-title>
						<div><span class="headline">مدیریت وام</span></div>
						<v-spacer />
						<v-btn @click="dialogCustomerManager = false" icon>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<manage-loan ref="manageLoan" v-if="dialogCustomerManager" :data="{ customer: selectedCustomer }" />
					</v-card-text>
				</v-card>
			</v-dialog>

			<div class="d-flex" style="position: absolute;bottom: 0;left: 0;
    right: 0;
    font-size: 18px;
    background-color: rebeccapurple;
    color: #fff;
		justify-content: end;
    flex-wrap: wrap;">
				<div class="text-center px-3 py-3">
					مجموع پرداخت های موفق: {{ sumSuccessPayments.toString().toPriceFormat() }}
				</div>
			</div>

		</material-card>
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import ManageLoan from '@/views/admin/ManageLoan.vue'
	import { sumBy } from 'lodash'

	export default {
		name: 'SuperAdmin_Purchases',
		props: {
			data: { type: Object },
			autoLoad: { type: Boolean },
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'date-navigator': () => import('@/components/DateNavigator'),
			'gateway-details': () => import('@/components/GatewayDetails'),
			ManageLoan
		},
		data() {
			return {
				filters: [],
				filter: 'همه',
				search: '',
				loading: false,
				headers: [
					{
						text: 'مشتری',
						align: 'right',
						sortable: true,
						value: 'customer.name',
						width: 100
					}, {
						text: 'توضیحات تراکنش',
						align: 'center',
						sortable: true,
						value: 'description',
						width: 250
					}, {
						text: 'زمان',
						align: 'center',
						sortable: true,
						value: 'startDate_Persian',
					}, {
						text: 'درگاه',
						align: 'center',
						sortable: true,
						value: 'onlinePaymentGatewayText',
					}, {
						text: 'مبلغ (تومان)',
						align: 'center',
						sortable: true,
						value: 'amount',
					}, {
						text: 'جزئیات تراکنش',
						align: 'right',
						sortable: true,
						value: 'zarinPalPurchase',
					}, {
						text: 'ثبت نهایی پرداخت',
						align: 'center',
						sortable: true,
						value: 'isPaymentSuccess',
						width: 150
					}
				],
				items: [],
				dateRange: { start: new Date(new Date().setMonth(new Date().getMonth() - 1)).toJSON(), end: '' },
				selectedCustomer: null,
				dialogCustomerManager: false
			}
		},
		computed: {
			excelFileName() {
				let name = 'لیست رکورد های درگاه پرداخت'
				name += '.xls'
				return name
			},
			hasCustomer() {
				return !!this.data?.customerId
			},
			title() {
				if (this.$route.query.onlywallet)
					return 'لیست واریز/برداشت های کیف پول'
				return 'لیست تراکنش های درگاه پرداخت'
			},
			sumSuccessPayments() {
				return sumBy(this.filterItems.filter(x => x.isPaymentSuccess), (x) => x.amount)
			},
			filterItems() {
				if (this.filter === 'همه')
					return this.items

				return this.items.filter(x => x.productType === this.filter)
			}
		},
		mounted() {
			if (this.autoLoad)
				this.loadData()
		},
		methods: {
			loadData() {
				this.loading = true
				let url = 'superadmin/Purchase/List/?start=' + this.dateRange.start + '&end=' + this.dateRange.end + `${this.hasCustomer ? '&customerId=' + this.data.customerId : ''}`
				if (this.$route.query.onlywallet)
					url = 'superadmin/Purchase/WalletList/?start=' + this.dateRange.start + '&end=' + this.dateRange.end + `${this.hasCustomer ? '&customerId=' + this.data.customerId : ''}`
				api.get(url, {})
					.then(
						response => {
							this.items = response
							this.filters = [...new Set(response.map(x => x.productType))]
							if (this.filters.length)
								this.filters.push('همه')
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.loading = false })
			},
			paymentSuccessColor(status) {
				return status ? 'success' : 'error'
			},
			paymentSuccessIcon(status) {
				return status ? 'mdi-check-circle' : 'mdi-close-circle'
			},
			showManageCustomer(customer) {
				this.selectedCustomer = customer
				this.dialogCustomerManager = true
			},
			translate(val) {
				switch (val) {
					case 0:
						return 'نسخه دائم'
					case 1:
						return 'شارژ پرونده'
					case 2:
						return 'شارژ پیامک'
					case 'همه':
						return 'همه'
					default:
						return 'نامشخص'
				}
			}
		},
	}
</script>
<style></style>
